import React from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'

export const FilterFormSections = ({ unassignedKey }) => {
  const [currentState, dispatch] = useStateValue()

  const handleSectionClicked = section => {
    let selectedSections = [...currentState.selectedSections]
    var i = selectedSections.indexOf(section)

    if (i === -1) {
      selectedSections.push(section)
    } else {
      selectedSections.splice(i, 1)
    }
    dispatch({
      type: 'UPDATE_SELECTED_SECTIONS',
      payload: selectedSections,
    })
  }

  return (
    <div className="multi-state-choice-field">
      <input
        className="form-control multi-state-choice-field-control"
        id="course-sections"
        name="course-sections"
        type="hidden"
        value=""
      />
      <ul className="multi-state-choice-field-list">
        <li
          className="multi-state-choice-field-item d-flex"
          onClick={() => handleSectionClicked(unassignedKey)}
        >
          {currentState.selectedSections.includes(unassignedKey) ? (
            <div className="multi-state-choice-field-state active">
              <div className="icon icon_checkbox_checked2 icon_color_primary" />
            </div>
          ) : (
            <div className="multi-state-choice-field-state active">
              <div className="icon icon_checkbox_unchecked" />
            </div>
          )}
          <div className="multi-state-choice-field-text ml-2">
            Unassigned Students
          </div>
        </li>
        {currentState.sections.map((section, i) => (
          <li
            className="multi-state-choice-field-item d-flex"
            onClick={() => handleSectionClicked(section)}
            key={i}
          >
            {currentState.selectedSections.includes(section) ? (
              <div className="multi-state-choice-field-state active">
                <div className="icon icon_checkbox_checked2 icon_color_primary" />
              </div>
            ) : (
              <div className="multi-state-choice-field-state active">
                <div className="icon icon_checkbox_unchecked" />
              </div>
            )}
            <div className="multi-state-choice-field-text ml-2">{section}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

FilterFormSections.propTypes = {
  unassignedKey: PropTypes.string.isRequired,
}
